import React, { useEffect, useState } from "react";
import NoSearchitems from "../../../../../components/NoSearchitems";
import DropdownCategories from "../../Components/DropdownCategories";

const NetflowTable = ({ data, outflow }) => {
  const [showAll, setShowAll] = useState(false);
  const [filter, setFilter] = useState({
    name: "Overall",
    value: "overall_categorization",
  });

  const [netflowTable, setNetflowTable] = useState([]);

  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }

  const formatMonth = (text) => {
    const [month, year] = text.split("-");
    const formattedMonth =
      month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
    return `${formattedMonth} ${year}`;
  };

  useEffect(() => {
    setNetflowTable(data ? data[filter.value]?.netflow_table : []);
    console.log(data ? data[filter.value]?.netflow_table : []);
  }, [filter, data]);

  return (
    <div className=" border border-[#e6ebed] rounded-lg">
      <div className="flex justify-between items-center h-[45px] px-4 pt-3">
        <p className=" text-base font-bold">Netflow Table</p>
        <DropdownCategories filterValue={filter} setFilterValue={setFilter} />
      </div>
      <div className=" flex ">
        <table className="w-[40%] box-border flex flex-col mt-4 rounded ">
          <thead className="text-xs font-semibold bg-[#f3f3f3]  ">
            <tr className="w-full flex items-center font-semibold text-sm">
              <th className="text-left pl-4  pt-3 pb-3 w-[50%]">Categories</th>
              <th className={`text-right w-[30%]`}>Amount</th>

              {/* <th className="text-right w-[15%] pl-14">Days</th> */}
            </tr>
          </thead>

          <tbody className={`   ${[]?.length === 0 ? " " : ""}`}>
            {[1]?.length === 0 && (
              <>
                <NoSearchitems />
              </>
            )}

            <>
              {netflowTable?.map((item, index) => {
                if (showAll === false && index > 2) {
                  return <></>;
                }
                return (
                  <tr
                    key={index}
                    className={`text-xs font-bold w-full flex items-center h-[43px] border-b border-[#e6ebed] `}
                  >
                    <td className="text-left  w-[50%] font-medium pl-4">
                      {item?.category}
                    </td>
                    <td className={`text-right w-[30%] pt-3 pb-2 font-bold`}>
                      {formatToIndianRupees(item.total) || "--"}
                    </td>
                    {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                  </tr>
                );
              })}
              <tr
                className={`text-xs font-bold w-full flex items-center h-[43px] `}
              >
                <td className="text-left  w-[50%] font-medium pl-4">
                  <button
                    onClick={() => {
                      setShowAll(!showAll);
                    }}
                    className=" underline"
                  >
                    Show {showAll ? "less" : "all"}{" "}
                  </button>
                </td>
                <td className={`text-right w-[30%] pt-3 pb-2 font-bold`}></td>
                {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
              </tr>
            </>
          </tbody>
        </table>
        <div className=" w-[60%] overflow-x-auto ">
          <table className="min-w-fit box-border flex flex-col mt-4 rounded ">
            <thead className="text-xs font-semibold bg-[#f3f3f3]  ">
              <tr className="w-full flex items-center font-semibold text-sm">
                {Object.keys(netflowTable[0] ? netflowTable[0] : {}).map(
                  (month, index) => {
                    if (month === "total" || month === "category") return <></>;
                    return (
                      <th className={`text-right w-[147px] pr-4 pt-3 pb-3`}>
                        {formatMonth(month) || "--"}
                      </th>
                    );
                  }
                )}

                {/* <th className="text-right w-[15%] pl-14">Days</th> */}
              </tr>
            </thead>

            <tbody className={`   ${[]?.length === 0 ? " " : ""}`}>
              {[1]?.length === 0 && (
                <>
                  <NoSearchitems />
                </>
              )}

              <>
                {netflowTable.map((item, index) => {
                  if (showAll === false && index > 2) {
                    return <></>;
                  }
                  return (
                    <tr
                      className={`text-xs  w-full flex items-center h-[43px] border-b border-[#e6ebed] `}
                    >
                      {Object.keys(item).map((key, index) => {
                        if (key === "total" || key === "category") return <></>;
                        return (
                          <td
                            className={`text-right w-[147px] pr-4 pt-3 pb-2 font-bold`}
                          >
                            {formatToIndianRupees(item[key]) || "--"}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default NetflowTable;
